module.exports = __webpack_public_path__ + "static/media/ufo.85aecfc0.svg";